import { AjaxClient } from '../AjaxClient';
import { AuthenticationInfo } from '../../model/AuthenticationInfo';

export class AccountApi {
  private client: AjaxClient;

  constructor(protected authInfo: AuthenticationInfo) {
    this.client = new AjaxClient(this.authInfo);
  }


  updateAccount(data: any) {
    return this.client.put(`${URL_API_HOST}/api/v1/profile/${this.authInfo.accountId}`, data);
  }

  getReal = () => {
    return { account: null, loading: false, offline: false };
  };
  getCurrent = () => {
    return { account: null, loading: false, offline: false };
  };
}
